import React, { useState } from "react";
import { useAuthContext } from "hooks/useAuthContext";

import { Card, Grid, Menu } from "@mui/material";
import { MoreVert, PictureAsPdf, Slideshow } from "@mui/icons-material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import NotificationItem from "examples/Items/NotificationItem";

import Patience from "../components/patience";
import ReportDocumentSection from "../components/reportDocumentSection";
import DetailSection from "../components/detailSection";
import ReportPresentationSection from "../components/reportPresentationSection";

const Report = ({ onSubmit }) => {
  const { user } = useAuthContext();
  const stage = user.project.stage;

  const [menu, setMenu] = useState(null);

  const [presentation, setPresentation] = useState(false);
  const [documentation, setDocumentation] = useState(true);
  const [title, setTitle] = useState("Documentation");

  const openMenu = ({ currentTarget }) => {
    setMenu(currentTarget);
  };
  const closeMenu = () => setMenu(null);

  const handlePresentationClick = () => {
    setTitle("Presentation");
    setPresentation(true);
    setDocumentation(false);
    closeMenu();
  };

  const handleDocumentationClick = () => {
    setTitle("Documentation");
    setDocumentation(true);
    setPresentation(false);
    closeMenu();
  };

  const renderMenu = (
    <Menu
      id="simple-menu"
      anchorEl={menu}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(menu)}
      onClose={closeMenu}
    >
      <NotificationItem
        icon={<Slideshow sx={{ color: "#FF9800" }} />}
        title="Presentation"
        onClick={handlePresentationClick}
      />
      <NotificationItem
        icon={<PictureAsPdf color="error" />}
        title="Document"
        onClick={handleDocumentationClick}
      />
    </Menu>
  );

  return stage === "Report" ? (
    <MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8} lg={8}>
          <Card sx={{ height: "100%" }}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              px={3}
              pt={3}
            >
              <MDBox ml={2}>
                <MDTypography variant="h5" gutterBottom>
                  {title}
                </MDTypography>
              </MDBox>
              <MDBox color="text" px={2}>
                <MoreVert
                  sx={{ cursor: "pointer", fontWeight: "bold" }}
                  fontSize="small"
                  onClick={openMenu}
                />
              </MDBox>
              {renderMenu}
            </MDBox>
            {presentation && <ReportPresentationSection onClick={onSubmit} />}
            {documentation && <ReportDocumentSection onClick={onSubmit} />}
          </Card>
        </Grid>
        <Grid item xs={12} md={4} lg={4}>
          <DetailSection />
        </Grid>
      </Grid>
    </MDBox>
  ) : stage === "Concept Paper" || stage === "Proposal" ? (
    <Patience />
  ) : (
    <Card sx={{ height: "100%" }}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={3}
        pt={3}
      >
        <MDBox ml={2}>
          <MDTypography variant="h5" gutterBottom>
            {title}
          </MDTypography>
        </MDBox>
        <MDBox color="text" px={2}>
          <MoreVert
            sx={{ cursor: "pointer", fontWeight: "bold" }}
            fontSize="small"
            onClick={openMenu}
          />
        </MDBox>
        {renderMenu}
      </MDBox>
      {presentation && <ReportPresentationSection />}
      {documentation && <ReportDocumentSection />}
    </Card>
  );
};

export default Report;
